import type {
  CampaignAnalyticMetricSelectFragment,
  CampaignAnalyticSelectFragment,
} from '~/api/graphql/fragments/campaignAnalytic.generated';
import type { IVariantType } from '~/modules/campaign/types';

export enum EMetricKey {
  SESSION = 'sessions',
  ORDERS = 'orders',
  PAGE_VIEWS = 'pageviews',
  VISITORS = 'visitors',
  BOUNCE_RATE = 'bounce_rate',
  CTR = 'ctr',
  CONVERSION_RATE = 'conversion_rate',
  AVG_TIME_ON_PAGE = 'average_time_on_page',
  ADDED_TO_CART = 'added_to_cart',
  ADD_TO_CART_RATE = 'added_to_cart_rate',
  REACHED_CHECKOUT = 'sessions_that_reached_checkout',
  COMPLETE_CHECKOUT = 'sessions_that_completed_checkout',
  CART_ADDITION = 'sessions_with_cart_additions',
  AOV = 'aov',
  REVENUE = 'revenue',
  RPV = 'revenue_per_visitor',
}

export interface IAnalyticMetric extends CampaignAnalyticMetricSelectFragment {
  variantKey: IVariantType;
}

export interface ICampaignAnalytic extends CampaignAnalyticSelectFragment {
  variantKey: IVariantType;
  metrics: IAnalyticMetric[];
}
